import React, { useEffect, useState } from 'react';
// @ts-ignore
import styles from './PredefinedPhrasesList.module.scss';
import AddButton from '../../../../Components/Button/AddButton';
import PredefinedPhrasesFormModal from './PredefinedPhrasesFormModal';
import PredefinedPhrasesListItem from './PredefinedPhrasesListItem/PredefinedPhrasesListItem';
import FlatList from '../../../Base/Components/FlatList';
import ScrollContainer from '../../../Base/Components/ScrollContainer';
import { PhraseType, useLazyMyPhrasesQuery } from '../../../../graphql/graphql';
import useMyPhrases from '../../Hooks/useMyPhrases';
import useFlatData from '../../../Base/Hooks/useFlatData';

interface Props {
	type: PhraseType;
	onEdit?: () => void;
}

export interface PredefinedPhrase {
	id: string;
	rank: number;
	value: string;
	type: PhraseType;
	name: string;
	meta: {
		id: string;
		key: string;
		value: string;
		formattedValue: string;
	};
}

const WRAPPER_ID = 'predefinedPhrasesListWrapper';

const PredefinedPhrasesList: React.FC<Props> = ({ type, onEdit }) => {
	const [isNewOpen, setNewOpen] = useState(false);

	const [getMyPhrasesQuery, { data, isLoading }] = useLazyMyPhrasesQuery();

	const { getMyPhrases, getNextPage, page, setPage } =
		useMyPhrases(getMyPhrasesQuery);

	const { flatData, hasMoreData, loadData, setFilter } = useFlatData(
		getMyPhrases,
		{
			data: data?.myPhrases?.data,
			totalPages: data?.myPhrases?.meta?.totalPages,
			page: data?.myPhrases?.meta?.page,
		},
		page,
		setPage,
		{
			type,
		},
	);

	const handleOnEdit = () => {
		loadData();
		onEdit?.();
	};

	const handleOnCreateNewPhrase = () => {
		setNewOpen(false);
		loadData();
	};

	useEffect(() => {
		setFilter({ type });
	}, [type]);

	return (
		<>
			<div className={styles.wrapper}>
				<div className={styles.controls}>
					<AddButton
						onClick={() => setNewOpen(true)}
						title='component.predefinedPhrasesList.addButton'
					/>
				</div>
				<ScrollContainer wrapperId={WRAPPER_ID}>
					<FlatList
						onRefresh={loadData}
						onLoadMore={getNextPage}
						data={flatData}
						isLoading={isLoading}
						hasMoreData={hasMoreData}
						scrollableTargetId={WRAPPER_ID}
						itemKey={'id'}
						className={styles.list}
						renderItem={item => (
							<PredefinedPhrasesListItem
								type={type}
								item={item}
								key={item.id}
								onEdit={handleOnEdit}
								onDelete={loadData}
							/>
						)}
					/>
				</ScrollContainer>
			</div>
			{isNewOpen && (
				<PredefinedPhrasesFormModal
					isOpen
					onClose={() => setNewOpen(false)}
					type={type}
					onSuccess={handleOnCreateNewPhrase}
				/>
			)}
		</>
	);
};

export default PredefinedPhrasesList;
